import { render, staticRenderFns } from "./m-planos.vue?vue&type=template&id=ff629a1c&scoped=true&"
import script from "./m-planos.vue?vue&type=script&lang=js&"
export * from "./m-planos.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=ff629a1c&scoped=true&lang=css&"
import style1 from "./m-planos.vue?vue&type=style&index=1&id=ff629a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff629a1c",
  null
  
)

export default component.exports